class DateUtils {
    static isDay = (hour: number = new Date().getHours()) => {
        // return true;
        return hour > 5 && hour < 18;
    }
}

export default DateUtils;


// WEBPACK FOOTER //
// ./src/utils/Date.tsx